import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { canMatchFn } from '@kanzi-apes/kanzi-auth';
import { KanziAnalyticsReportFlightStatusComponent } from './pages/kanzi-analytics-report-flight-status/kanzi-analytics-report-flight-status.component';
import { KanziAnalyticsReportComponent } from './pages/kanzi-analytics-report/kanzi-analytics-report.component';

export const routes: Routes = [
  {
    path: 'flight-report',
    component: KanziAnalyticsReportFlightStatusComponent,
    canActivate: [canMatchFn],
  },
  {
    path: 'embed-report',
    component: KanziAnalyticsReportComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class KanziAnalyticsReportRountingModule {}
